import { InvoiceSendingTypeStringEnum } from '../models/enums/InvoiceSendingTypeString.enum';
import { getInvoicePdfById } from '../services/invoiceService';

export const downloadInvoicePdf = async (id, loadingCallback, sendingType?: InvoiceSendingTypeStringEnum) => {
  loadingCallback(true);
  try {
    await getInvoicePdfById(id, sendingType)
      .then(
        (response) =>
          new Blob([response.data], {
            type: 'application/pdf',
          }),
      )
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `faktura_${id}.pdf`;
        a.click();
        a.remove();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          loadingCallback(false);
        }, 100);
      });
  } catch (err) {
    loadingCallback(false);
  }
};
